export enum CommunityArticleAIState {
    NONE = 0,
    WAITING_IA = 1,
    ERROR = 2,
    DONE = 3
}